module.exports = __webpack_public_path__ + "media/practice.f3f012da.mp3";